import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'relative inline-flex items-center rounded-sm justify-center gap-2 overflow-hidden whitespace-nowrap cursor-pointer text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary-hover hover:text-primary-foreground-hover disabled:bg-primary',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive-hover',
        outline: 'border bg-transparent hover:bg-accent hover:text-accent-foreground hover:border-accent',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary-hover',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        header: 'font-normal rounded-sm hover:bg-secondary hover:text-secondary-foreground !px-3',
        sidebar: 'justify-start hover:bg-secondary hover:text-secondary-foreground',
        icon: 'hover:bg-secondary hover:text-secondary-foreground rounded-full disabled:text-muted-foreground flex-shrink-0',
        'icon-outline': 'border border-input bg-background hover:bg-accent hover:text-accent-foreground hover:border-accent rounded-full disabled:text-muted-foreground flex-shrink-0 disabled:bg-background disabled:border-border',
        'icon-glass': 'bg-background/60 backdrop-blur-md hover:bg-background/90 text-primary rounded-full disabled:opacity-40 flex-shrink-0 shadow-sm',
        link: 'text-yellow-700 dark:text-yellow-200 underline-offset-4 hover:underline !p-0 !h-auto rounded-none',
        accent: 'bg-accent text-accent-foreground hover:bg-accent-hover',
        success: 'bg-success text-success-foreground hover:bg-success-hover',
      },
      size: { default: 'h-10 px-4 py-2', xs: 'text-xs underline-offset-2 h-5 px-1', sm: 'h-9 px-3', lg: 'h-11 px-5', icon: 'h-10 w-10', 'icon-sm': 'h-9 w-9', 'icon-xs': 'h-6 w-6', 'icon-lg': 'h-12 w-12', sidebar: 'h-10 px-2.5 py-2' },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
);
